import React from "react";
import { NavLink } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-inner">
        {/* Bloc marque */}
        <div className="footer-brand">
          <NavLink to="/home" className="footer-logo">
            pdf-convert.fr
          </NavLink>

          <div className="footer-tagline">
            Conversion & compression – 100% dans votre navigateur.
          </div>
        </div>

        {/* Liens */}
        <nav className="footer-links" aria-label="Liens du site">
          <NavLink to="/faq" className="footer-link">
            FAQ
          </NavLink>

          <NavLink to="/mentions-legales" className="footer-link">
            Mentions légales
          </NavLink>

          <NavLink to="/confidentialite" className="footer-link">
            Confidentialité
          </NavLink>

          <NavLink to="/conditions" className="footer-link">
            Conditions
          </NavLink>

          <NavLink to="/a-propos" className="footer-link">
            À propos
          </NavLink>

          <a
            className="footer-link"
            href="mailto:contact@pdf-convert.fr"
            rel="nofollow"
          >
            Contact
          </a>
        </nav>
      </div>

      {/* Bas de footer */}
      <div className="footer-bottom">
        <span>© {year} pdf-convert.fr</span>
        <span className="footer-dot">•</span>
        <span>Fichiers traités localement</span>
      </div>
    </footer>
  );
}
